import { mapActions, mapGetters } from "vuex";
import { InitService } from "@/services";
import * as types from "@/store/types";
export default {
  name: "suggestion-apps",
  components: {},
  props: [],
  data() {
    return {
      pwaBaseUrl: process.env.VUE_APP_PWA_BASE_URL,
      downloadSheet: false,
      show: false,
      showModel: 1,
      isMobile: false,
      imageLinks: [
        {
          id: 1,
          image: require("@/assets/image/donwloadLinksIcons/google play.svg"),
          link:
            "https://play.google.com/store/apps/details?id=com.excoino.excoino&hl=en&gl=US",
          icon: "$googlePlay"
        },
        {
          id: 2,
          image: require("@/assets/image/donwloadLinksIcons/cafebazaar.svg"),
          link: "https://cafebazaar.ir/app/com.excoino.excoino"
        },
        {
          id: 3,
          image: require("@/assets/image/donwloadLinksIcons/Apk.svg"),
          link: "https://www.excoino.com/app/excoino_4_7.apk",
          icon: "$android"
        },
        {
          id: 3,
          image: require("@/assets/image/donwloadLinksIcons/Sibapp.svg"),
          link: "https://www.excoino.com/app/excoino_4_7.apk",
          icon: "$ios"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      initData: types.init.getters.GET_INIT_DATA
    })
  },
  watch: {
    initData: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.appLinks(newValue);
        }
      }
    }
  },
  mounted() {
    this.getInit();
    window.mobileCheck = function() {
      let check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };
    this.isMobile = !!window.mobileCheck();
    setTimeout(() => {
      this.show = !!window.mobileCheck();
    }, 2000);
  },
  methods: {
    ...mapActions({
      isAuthAction: types.auth.actions.ACTION_CHECK_IS_AUTH,
      setInit: types.init.actions.SET_INIT_DATA
    }),
    getInit() {
      InitService.init().then(res => {
        this.setInit(res.data.data);
      });
    },
    appLinks(data) {
      return this.imageLinks.map(link => {
        if (link.icon === "$android") {
          link.link = data.android_download_direct_link;
        }
        if (link.icon === "$ios") {
          link.link = data.ios_download_page;
        }
      });
    },
    ignoreInstallation() {
      this.show = false;
      this.downloadSheet = false;
    },
    setDownloadSheet() {
      this.show = false;
      this.downloadSheet = !this.downloadSheet;
    },
    redirectToPwa() {
      this.downloadSheet = !this.downloadSheet;
      window.location.replace(this.pwaBaseUrl);
    }
  }
};
